import { render } from "./Jam.vue?vue&type=template&id=acbb37d4&scoped=true"
import script from "./Jam.vue?vue&type=script&lang=js"
export * from "./Jam.vue?vue&type=script&lang=js"

import "./Jam.vue?vue&type=style&index=0&id=acbb37d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acbb37d4"]])

export default __exports__